(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('send1094c', directive);

  function directive(){
    var dir = {
      templateUrl: './app/views/retrasmit/retransmit1094C-main.html',
      controller: Controller,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        sendPage: '=',
        isSovosProfile: '=',
        isAdmin: '=',
        isEditor: '=',
        sendXmit: '&',
        goSendStatus: '&'
      }
    };

    return dir;
  }

  Controller.$inject = [
    'EmployerService',
    'CORRECTIONS_PAGE',
    'SEND_MESSAGES',
    'OUTPUT_TYPE',
    '$interval',
    'AuxiliaryOperationsService',
    'SETTINGS',
    'SendService',
    'UtilsService',
    '$window',
    '$mdDialog',
    '$scope',
    'XMIT_STATUS',
    'XMIT_PAGE',
    'CheckListService',
    '$location',
    'ManagedUserInformationService',
    'CommonTransmittalService',
  ];
  
  // jscs:disable maximumLineLength
  function Controller(
    EmployerService,
    CORRECTIONS_PAGE,
    SEND_MESSAGES,
    OUTPUT_TYPE,
    $interval,
    AuxiliaryOperationsService,
    SETTINGS,
    SendService,
    UtilsService,
    $window,
    $mdDialog,
    $scope,
    XMIT_STATUS,
    XMIT_PAGE,
    checkListService,
    $location,
    ManagedUserInformationService,
    CommonTransmittalService){
    var _this = this;
    _this.retransmit = {step:1};

    /** propeties */
    _this.errorReports = [];
    _this.family = [];
    _this.employer = {};
    _this.errorReportSubscribers = [];
    _this.errorReportsEmployers = [];
    _this.tinWithMask = '';
    _this.accountnoEmployer = '';
    _this.selectedXmitRun = '';
    _this.token = '';
    _this.filename = '';
    _this.shortfilename = '';
    _this.descriptionError = '';
    _this.currentEntity = {};
    _this.retrfansmit = {};
    _this.employers = [];
    _this.errorMessage = '';
    _this.employerRecords = [];
    _this.form = [];
    _this.employersSelected = false;
    _this.formsSelected = false;
    _this.payerCheckBoxIdPrefix = '#payer_';
    _this.FileParts = [];
    _this.showfilename = [];
    _this.xmitRun = [];
    _this.errorMessageXmit = [];
    _this.sendOptionFile = '';


    /**method */
    _this.retransmitConfirmation = _retransmitConfirmation;
    _this.sendTransmittalConfirmation = _sendTransmittalConfirmation;
    _this.sendXmit = _sendXmit;
    _this.goToStepOne = _goToStepOne;
    _this.closeModal = _closeModal;
    _this.cancelTransmitCorrected = _cancelTransmitCorrected;
    _this.goToSend = _goToSend;
    _this.back = _back;
    _this.isManagedServices = _isManagedServices;
    _this.showEmailAddress = _showEmailAddress;
    _activate();

    function _activate(){
      checkListService.getEmployers1094cCorrect().then(_setEmployerData);
    }

    function _setEmployerData(data){
      _this.employers = data;
    }

    /** @public */
    function _retransmitConfirmation(){
      //TODO: add functionality when is ready the new feature
      if(_requiredOptionIsMissing()){
        _this.retransmit.step = 2;
      }
    }

    function _closeModal(){
      $mdDialog.hide();
    }

    function _requiredOptionIsMissing(){
      _this.employersSelected = _this.employers.some(function(e){
        return !!e.selected;
      });
      _this.formsSelected = (_this.form.selected !== undefined);

      if(!_this.formsSelected){
        _this.errorMessage = CORRECTIONS_PAGE.NOFORMSSELECTED;
      }
      if(!_this.employersSelected){
        _this.errorMessage = CORRECTIONS_PAGE.NOPAYERSSELECTED;
      }

      return (_this.formsSelected && _this.employersSelected);
    }

    function getTotal(){
      var total = 0;
      var employer;
      for(var i = 0; i < _this.employerRecords.length; i++){
        employer = _this.employerRecords[i];
        total += employer.Ebreccount;
      }
      return total;
    };

    function setTransmittalConfig (outputType){
      if(aRequiredOptionIsMissing() === true){
        return true;
      }
      var rpcTransmittalRequest = getRpcRequest(outputType);
      return rpcTransmittalRequest;
    };

    function aRequiredOptionIsMissing(){
      if(_this.form.selected === false){
        _this.errorMessage = SEND_MESSAGES.NOFORMSELECTED;
        return true;
      }

      if(_this.form.selectedOptions === false && _this.showFormOptions){
        _this.errorMessage = SEND_MESSAGES.NOFORMSELECTED;
        return true;
      }
      if(_this.employers.length === 0){
        _this.errorMessage = SEND_MESSAGES.NOPAYERSELECTED;
        return true;
      }
      else{
        var isPayerSelected = false;
        for(var i = 0; i < _this.employers.length; i++){
          var isChecked = $(_this.payerCheckBoxIdPrefix + i).prop('checked');
          if(isChecked){
            isPayerSelected = true;
            break;
          }
        }
        if(!isPayerSelected){
          _this.errorMessage = SEND_MESSAGES.NOPAYERSELECTED;
          return true;
        }
      }
    };

    function getRpcRequest(outputType){
      return {
        Fchar: getFcharSelected(),
        Payers: getPayerSelected(),
        Output: outputType,
        FilingStatus: 'Correction',
        TransmittalType: 'Accepted & Accepted With Errors'
      };
    };

    function getFcharSelected(){
      return _this.form.selected;
    };

    function getPayerSelected(){
     var payers = '';
      for(var i = 0; i < _this.employers.length; i++){
        if($(_this.payerCheckBoxIdPrefix + i).prop('checked')){
          payers += $(_this.payerCheckBoxIdPrefix + i).attr('ng-true-value') + ',';
        }
      }
      payers = payers.replace(/'/g, '');
      return payers.slice(0, -1);
    }

    function finishServiceJob (renewToken){
      _this.jobProcessing = false;
      $interval.cancel(renewToken);
      $mdDialog.hide();
    };

    function showMessageFromSend (error){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      if(error.data.error.frontend_message !== '' && error.data.error.frontend_message !== undefined){
        _this.errorMessage = error.data.error.frontend_message;
      }
      else{
        _this.errorMessage = 'System Error';
      }
      _this.retransmit = {step:4};
      _this.outputType = 'aca';
    };

    function _goToSend(){
      _this.goSendStatus();
    }

    function autoPopulateBox20(rpcTransmittalRequest){
      SendService.autoPopulateBox20(rpcTransmittalRequest).then(
        function(error){
          $mdDialog.hide().finally(function(){
            showMessageFromSend(error);
          });
        }
      );
    };

    function executeTransmittal(url, rpcTransmittalRequest){
      _this.jobProcessing = true;
      var renewToken = $interval(
        function(){
          AuxiliaryOperationsService.RenewToken().then(function(){
          });
        }, SETTINGS.RENEWTOKEN_EACH_MILLISECONDS
      );
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: url,
        parent: angular.element(document.body)
      });
      SendService.generateXmit(rpcTransmittalRequest).then(
        function(data){
          finishServiceJob(renewToken);
          if(data.result.Filename !== '' && (data.result.Error === '' || data.result.Error === undefined)){
            _this.token = $window.sessionStorage.token;
            _this.FileParts = UtilsService.splitFilenameXmit(String(data.result.Filename));
            _this.showfilename = _this.FileParts[2] + '~' + _this.FileParts[3];
            _this.filename = _this.FileParts[1] + '~' + _this.showfilename;
            _this.xmitRun = data.result.XmitRun;
            _this.employerRecords = data.result.RecordsEmployer;
            _this.retransmit = { step: 2 };
          }
          else{
            _this.errorMessage = '';
            _this.errorMessageXmit = data.result.Error;
            $mdDialog.show({
              templateUrl: 'app/views/retrasmit/modals/error1094C-message-xmit.html',
              preserveScope: true,
              scope: $scope
            });
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          finishServiceJob(renewToken);
          $mdDialog.hide().finally(function(){
            _this.sendOptionFile = 'transmittal';
            showMessageFromSend(error);
          });
        }
      );
    };

     /** @public */
    function _cancelTransmitCorrected(){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/retrasmit/modals/cancel1094C-transmittal.html',
        parent: angular.element(document.body)
      });
      CommonTransmittalService.cancelTransmittal(_this.xmitRun, _this);
    }

    function _sendTransmittalConfirmation(){
      var rpcTransmittalRequest = setTransmittalConfig(OUTPUT_TYPE.TRANSMITTAL);
      if(rpcTransmittalRequest === true){
        return true;
      }
      autoPopulateBox20(rpcTransmittalRequest);
      executeTransmittal('app/views/retrasmit/modals/send1094C-processing-transmittal.html', rpcTransmittalRequest);
    }

    var errorOnTransmittal = function(error){
      $mdDialog.hide().finally(function(){
        $scope.sendOptionFile = 'transmittal';
        showMessageFromSend(error);
      });
    };

    function backListXmitStatus(){
      _this.sendPage = XMIT_PAGE.SEND_TRANSMITTAL_STATUS;
    };

    /** @public */
    function _goToStepOne(){
      _this.retransmit = {step:1};
    };

    /** @public */
    function _back(){
      _this.sendPage = SEND_MESSAGES.BACKCHECKLIST;
    }

    /** @public */
    function _isManagedServices(){
      return ManagedUserInformationService.isManagedServices();
    }

    /** @public */
    function _showEmailAddress(){
      SendService.getManagedServicesEmailList().then(function(data){
        var dataEmail = {
          listEmails: data.result,
          CodeTypeRun: _this.xmitRun,
          FileName: _this.showfilename,
          Fchar: _this.form.selected,
          JobId: 0,
          TypeFile: SETTINGS.TRANSMITTAL,
          TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL),
          OutputType: OUTPUT_TYPE.TRANSMITTAL.toLowerCase()
        };
        $mdDialog.show({
          scope: $scope,
          templateUrl: 'app/views/send/modals/send-email-to-approve.html',
          parent: angular.element(document.body),
          preserveScope: true,
          controller: 'SendEmailController as seCont',
          locals: {
            dataEmail: dataEmail
          }
        });
      });
    }

    /** @public */
    function _sendXmit(){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/send/modals/send-transmittal.html',
        parent: angular.element(document.body)
      });

      SendService.SendXmit(createObjectRequest('send')).then(
        function(data){
          var validStatus = data.result.Xmit.StatusInt === XMIT_STATUS.QUEUED ||
            data.result.Xmit.StatusInt === XMIT_STATUS.IRS_PROCESSING ||
            data.result.Xmit.StatusInt === XMIT_STATUS.COMPLETE ||
            data.result.Xmit.StatusInt === XMIT_STATUS.QUEUED_FOR_SUBMISSION;
          if(validStatus){
            $mdDialog.hide();
            if(data.result.isNpsCompleted !== 'Y'){
              $mdDialog.show({
                scope: $scope.$new(),
                preserveScope: true,
                templateUrl: 'app/views/questionIntegration/modals/question-integration.html',
                controller: 'QuestionIntegrationController'
              });
            }
            _this.sendPage = 'send-xmit-success';
            _this.retransmit = {step:3};
            _this.outputType = 'aca';
          }
          else{
            $mdDialog.hide();
            _this.sendPage = 'send-xmit-error';
            errorOnTransmittal(error);
          }
        }.bind(this),
        function(error){
          errorOnTransmittal(error);
        }
      );
    }

    /** @private */
    function createObjectRequest(action){
      var xmitRequest = {
        XmitRun: _this.xmitRun,
        JobId: 0,
        Hash: $scope.hash || $window.sessionStorage.hash,
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL)
      };
      switch(action){
        case 'send':
          xmitRequest.FileName = _this.showfilename;
        break;
        case 'cancel':
          xmitRequest.Fchar = '0';
        break;
      }
      return xmitRequest;
    }
  }
})();